import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";
import { useAppContext } from "../store";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { appLinks } from "./routes";

const Layout = lazy(() => import("../app/Layout"));
const SignIn = lazy(() => import("../containers/SignIn"));
const ForgotPassword = lazy(
  () => import("../containers/SignIn/ForgotPassword")
);
const ResetPassword = lazy(() => import("../containers/SignIn/ResetPassword"));

const RouterWrapper: React.FC = () => {
  const {
    state: { isAuth },
  } = useAppContext();

  return (
    <Suspense fallback={<Loader inline={false} height="100vh" />}>
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={
              <PrivateRoute isAuthenticated={isAuth}>
                <Layout />
              </PrivateRoute>
            }
          />
          <Route
            path={appLinks.signIn.link}
            element={
              <PublicRoute isAuthenticated={isAuth}>
                <SignIn />
              </PublicRoute>
            }
          />
          <Route
            path={appLinks.forgotPassword.link}
            element={
              <PublicRoute isAuthenticated={isAuth}>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path={appLinks.resetPassword.link}
            element={
              <PublicRoute isAuthenticated={isAuth}>
                <ResetPassword />
              </PublicRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
};

export default RouterWrapper;
